import React from "react";

import styles from "./Button.module.scss";

const Button = (props) => {
  return (
    <button {...props} className={[props.className, styles.button].join(" ")} />
  );
};

export default Button;
